import createIcon from '../../createIcon';

/**
 * @component @name SportsFootball
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy4wMjAxIDE1LjYyMDRDMi45NDAxIDE4LjA0MDQgMy4zNDAxIDE5Ljk2MDQgMy42OTAxIDIwLjMxMDRDNC4wNDAxIDIwLjY2MDQgNS45NzAxIDIxLjA3MDQgOC4zODAxIDIwLjk4MDRMMy4wMjAxIDE1LjYyMDRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuMDgwMSAzLjI4MDQxQzEwLjc1MDEgMy43MDA0MSA4LjI5MDEgNC42MjA0MSA2LjQ2MDEgNi40NjA0MUM0LjYzMDEgOC4zMDA0MSAzLjcwMDEgMTAuNzUwNCAzLjI4MDEgMTMuMDgwNEwxMC45MTAxIDIwLjcxMDRDMTMuMjUwMSAyMC4zMDA0IDE1LjcwMDEgMTkuMzcwNCAxNy41MzAxIDE3LjUzMDRDMTkuMzYwMSAxNS42OTA0IDIwLjI5MDEgMTMuMjQwNCAyMC43MTAxIDEwLjkxMDRMMTMuMDgwMSAzLjI4MDQxWk05LjkwMDEgMTUuNTAwNEw4LjUwMDEgMTQuMTAwNEwxNC4xMDAxIDguNTAwNDFMMTUuNTAwMSA5LjkwMDRMOS45MDAxIDE1LjUwMDRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAuOTgwMSA4LjM4MDQxQzIxLjA2MDEgNS45NjA0MSAyMC42NjAxIDQuMDQwNDEgMjAuMzEwMSAzLjY5MDQxQzE5Ljk2MDEgMy4zNDA0MSAxOC4wMzAxIDIuOTMwNDEgMTUuNjIwMSAzLjAyMDQxTDIwLjk4MDEgOC4zODA0MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SportsFootball = createIcon('SportsFootball', [
  [
    'path',
    {
      d: 'M3.0201 15.6204C2.9401 18.0404 3.3401 19.9604 3.6901 20.3104C4.0401 20.6604 5.9701 21.0704 8.3801 20.9804L3.0201 15.6204Z',
      key: 'ccu0jj',
    },
  ],
  [
    'path',
    {
      d: 'M13.0801 3.28041C10.7501 3.70041 8.2901 4.62041 6.4601 6.46041C4.6301 8.30041 3.7001 10.7504 3.2801 13.0804L10.9101 20.7104C13.2501 20.3004 15.7001 19.3704 17.5301 17.5304C19.3601 15.6904 20.2901 13.2404 20.7101 10.9104L13.0801 3.28041ZM9.9001 15.5004L8.5001 14.1004L14.1001 8.50041L15.5001 9.9004L9.9001 15.5004Z',
      key: '1tacxm',
    },
  ],
  [
    'path',
    {
      d: 'M20.9801 8.38041C21.0601 5.96041 20.6601 4.04041 20.3101 3.69041C19.9601 3.34041 18.0301 2.93041 15.6201 3.02041L20.9801 8.38041Z',
      key: '1pwgyj',
    },
  ],
]);

export default SportsFootball;
